import React from 'react';
import InfoCompra from '../InfoCompra';

const InfoPtp = ({ children, label, resultado, referencia, valor, periocidadPago, pago }) => {
  return (
    <div className="row justify-content-center mt-4 mt-md-5">
      {console.log('INFO ptp pago', pago)}
      <InfoCompra label={label} total={valor} periocidadPago={periocidadPago} />
      <div className="col-10 col-sm-8 text-center">
        <h6 className="font-weight-bold text-secondary">Resultado: {resultado}</h6>
        <h6 className="font-weight-bold text-secondary">Ref Cotización: {referencia}</h6>
        <h6 className="font-weight-bold text-secondary">Referencia Pago: {pago?.pago_id}</h6>
      </div>
      {children}
    </div>
  );
};

export default InfoPtp;
